import { links, MainLinkId, USER_DETAILS_ENDPOINT } from './constants';
export const getUserDetails = ({ httpClient, }) => {
    return httpClient
        .get(USER_DETAILS_ENDPOINT, {
        headers: {
            Accept: 'application/json',
        },
        withCredentials: true,
    })
        .then((response) => response.data.user);
};
export const getCookie = (name) => {
    const cookie = document.cookie.match(new RegExp('(^|;\\s*)' + name + '=([^;]*)'));
    return cookie && cookie[2];
};
export const getActiveLink = (url) => {
    if (url.startsWith(links.mainLinks.myApps)) {
        return MainLinkId.MyApps;
    }
    if (url.startsWith(links.mainLinks.apiReference)) {
        return MainLinkId.ApiReference;
    }
    if (url.startsWith(links.mainLinks.support)) {
        return MainLinkId.Support;
    }
    if (url.startsWith(links.mainLinks.appTemplates)) {
        return MainLinkId.appTemplates;
    }
    return MainLinkId.MyApps;
};
export const getLoginLink = (afterLoginLink = 'https:%2F%2Fdev.wix.com%2Fdc3%2Fmy-apps') => `${links.signInButton}&postLogin=${afterLoginLink}&postSignUp=${afterLoginLink}`;
export const getLogoutLink = (afterLogoutLink = 'https://dev.wix.com') => `${links.logoutButton}?redirectTo=${afterLogoutLink}`;
//# sourceMappingURL=utils.js.map